import React, { useState, useMemo, useRef, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';
import CreateInventoryModal from 'components/add_inventory/CreateInventoryModal';
import InventoryQuantityEditModal from 'components/add_inventory/InventoryQuantityEditModal';

import { inventoryApi } from 'api';

import {
  INVENTORY_LIST_TAB,
  INVENTORY_LIST_COLUMNS,
  INVENTORY_FILTER_OPTIONS,
} from 'constants/inventory';

const Inventory = () => {
  const tableRef = useRef();
  const [showCreateInventoryModal, setShowCreateInventoryModal] =
    useState(false);
  const [showQuantityEditModal, setShowQuantityEditModal] = useState(false);
  const [quantityEditModalConfig, setQuantityEditModalConfig] = useState({
    inventory: null,
    type: '',
  });

  const { selectedWarehouse } = useUserContext();
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const handleShowQuantityEditModal = (inventory, type) => {
    setQuantityEditModalConfig({ inventory, type });
    setShowQuantityEditModal(true);
  };

  const handleCloseQuantityEditModal = () => {
    setShowQuantityEditModal(false);
    setQuantityEditModalConfig({ inventory: null, type: '' });
  };

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateInventoryModal(true)}
    >
      Create Inventory
    </Button>
  );

  const exportApi = useCallback(params => {
    return inventoryApi.exportInventory(params);
  }, []);

  const extendedColumns = useMemo(() => {
    const actionColumn = {
      id: 'actions',
      header: 'Actions',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-center' },
        cellProps: { className: 'text-center' },
      },
      cell: ({ row: { original } }) => (
        <div className="d-flex justify-content-center gap-2">
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleShowQuantityEditModal(original, 'update')}
          >
            Update
          </Button>
          <Button
            variant="success"
            size="sm"
            onClick={() => handleShowQuantityEditModal(original, 'add')}
          >
            Add
          </Button>
        </div>
      ),
    };

    return [...INVENTORY_LIST_COLUMNS, actionColumn];
  }, []);

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Inventory"
        apiService={inventoryApi}
        exportApi={exportApi}
        sortable={true}
        columns={extendedColumns}
        filterOptions={INVENTORY_FILTER_OPTIONS}
        tabOptions={INVENTORY_LIST_TAB}
        initialFilter={initialFilter}
        initialPageSize={25}
        headerActions={headerActions}
      />

      <CreateInventoryModal
        show={showCreateInventoryModal}
        onHide={() => setShowCreateInventoryModal(false)}
        onSuccess={handleActionSuccess}
      />

      <InventoryQuantityEditModal
        show={showQuantityEditModal}
        onHide={handleCloseQuantityEditModal}
        inventory={quantityEditModalConfig.inventory}
        type={quantityEditModalConfig.type}
        onSuccess={handleActionSuccess}
      />
    </>
  );
};

export default Inventory;
